import { useEffect, useRef, useState } from 'react'
import { isAnyBlank } from '../../utils/string'
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField
} from '@mui/material'
import AsignaturaSelector from '../../components/form/AsignaturaSelector/AsignaturaSelector'
import css from './ModalNuevoCuadernillo.module.css'

const ModalNuevoCuadernillo = ({ open, onSubmit, onClose, isLoading }) => {
  const [cuadernillo, setCuadernillo] = useState({
    nombre: '',
    asignaturas: []
  })

  const [selectedFile, setSelectedFile] = useState(null)
  const inputRef = useRef(null)

  useEffect(() => {
    if (open) {
      setCuadernillo({ nombre: '', asignaturas: [] })
      setSelectedFile(null)
    }
  }, [open])

  const isSubmitDisabled = isAnyBlank(cuadernillo.nombre) || !selectedFile

  const handleSubmit = () => {
    onSubmit({
      nombre: cuadernillo.nombre,
      archivo: selectedFile,
      asignaturas: cuadernillo.asignaturas
    })
  }

  const handleFileChange = e => {
    if (e.target.files.length > 0) {
      setSelectedFile(e.target.files[0])
    }
  }

  const handleUploadClick = () => {
    inputRef.current?.click()
  }

  return (
    <Dialog onClose={onClose} open={open} fullWidth maxWidth='md'>
      <DialogTitle>Nuevo cuadernillo</DialogTitle>
      <DialogContent className={css.main}>
        <DialogContentText className={css.intro}>
          Utiliza este formulario para crear un nuevo cuadernillo
        </DialogContentText>
        <TextField
          className={css.input}
          label='Nombre'
          value={cuadernillo.nombre}
          onChange={e =>
            setCuadernillo({ ...cuadernillo, nombre: e.target.value })
          }
          variant='standard'
        />
        <AsignaturaSelector
          multiple
          className={css.input}
          name='asignatura'
          label='Asignatura'
          value={cuadernillo.asignaturas}
          onChange={(_e, value) =>
            setCuadernillo({
              ...cuadernillo,
              asignaturas: value.map(a => a.id) || []
            })
          }
        />
        <div className={css.file}>
          <p>Adjuntar archivo PDF del cuadernillo</p>
          <Button size='small' type='secondary' onClick={handleUploadClick}>
            Seleccionar cuadernillo
          </Button>
          <input
            ref={inputRef}
            type='file'
            accept='application/pdf'
            name='pdf'
            onChange={handleFileChange}
            hidden
          />
          {selectedFile && (
            <span className={css.filename}>{selectedFile.name}</span>
          )}
        </div>
      </DialogContent>
      <DialogActions>
        <Button color='error' onClick={onClose}>
          Cancelar
        </Button>
        <Button
          disabled={isSubmitDisabled || isLoading}
          color='primary'
          onClick={handleSubmit}
          startIcon={isLoading && <CircularProgress size={12} />}
        >
          Enviar
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ModalNuevoCuadernillo
